import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIUrl } from 'src/app/features-common/constants/APIUrls';
import { BaseService } from 'src/app/framework/services/base.service';

@Injectable({
  providedIn: 'root'
})
export class WalletService extends BaseService {
  constructor() {
    super();
  }

  getSlaesRepList(): Observable<any> {
    return this.httpService.get(APIUrl.getSalesRepsList)
  }
  getSalesRepDetailsById(id): Observable<any> {
    return this.httpService.get(`${APIUrl.getSalesRepsList}/${id}`)
  }
  // Get all Retailer List details
  getallRetailerList(): Observable<any> {
    return this.httpService.get(APIUrl.retailersList)
  }


  getallRetailerDetailsById(retailerId: string): Observable<any> {

    return this.httpService.get(APIUrl.walletretailerDetails + '/' + retailerId)
  }

  addReatilerAmount = (parms): Observable<any> => {
    return this.httpService.postParams(APIUrl.retailerAddFunds, parms);
  }

  removeReatilerAmount = (parms): Observable<any> => {
    return this.httpService.postParams(APIUrl.retailerRemoveFunds, parms);
  }

  addSalesRepAmount = (params): Observable<any> => {
    return this.httpService.postParams(APIUrl.retailerSalesRepAddFunds, params)
  }

  removeSalesRepAmount = (params): Observable<any> => {

    return this.httpService.postParams(APIUrl.retailerSalesRepRemoveFunds, params)
  }

  getRetaileFundDetailByAccountIdAndId = (parms): Observable<any> => {
    return this.httpService.getParams(APIUrl.retailerFundDetailsByretailerAccountNumAndretailerId, parms);
  }

  getSlaesRepRetailerList(): Observable<any> {
    return this.httpService.get(APIUrl.getSalesRepRetailerList)
  }
  getSlaesReproleRetailerList(): Observable<any> {
    return this.httpService.get(APIUrl.getSalesReproleRetailerList)
  }

  addRetailerMoney = (formData): Observable<any> => {
    return this.httpService.put(APIUrl.addRetailerMoney, formData)
  }
  addSalesrepMoney = (formData): Observable<any> => {
    return this.httpService.post(APIUrl.addSalesRepMoney, formData)
  }

  getCreditlineReport = (params): Observable<any> => {

    return this.httpService.getParams(APIUrl.credeitLineReport,params)
  }



}
